webpackJsonp([12],{

/***/ "6Yz8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isMobile: true,
      instaToken: ''
    };
  },

  methods: {
    checkForMobile: function checkForMobile() {
      this.isMobile = window.innerWidth < 600;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.checkForMobile();
    window.addEventListener('resize', function () {
      _this.checkForMobile();
    });
    document.getElementById('is-video').play();
  },
  created: function created() {
    var _this2 = this;

    window.api.get('get-pages-by-type/2').then(function (res) {
      _this2.projects = res.data.data;
    }).then(function () {
      _this2.$setTweens();
    });

    window.api.get('get-insta').then(function (res) {
      _this2.instaToken = res.data;
    });
    this.$setSeo('Graphic Design Agency / Web Design / Brand Consultants Midlands | Alt Design', 'Based in Derby, Alt Design are one of the top graphic design agencies in the Midlands specialising in branding, print, and web design. Call us on 01332 208733.');
  }
});

/***/ }),

/***/ "8n4o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Homepage_vue__ = __webpack_require__("6Yz8");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86a477b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Homepage_vue__ = __webpack_require__("p9IS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Homepage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_86a477b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Homepage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "p9IS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"homepage page type-page status-publish hentry"},[_c('div',{staticClass:"container"},[_c('header',{staticClass:"entry-header",staticStyle:{"position":"absolute","width":"100%"}},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"more"},[_c('router-link',{attrs:{"to":"/work","title":"Take a peek"}},[_vm._v("Take a peek")])],1)]),_vm._v(" "),_c('div',{attrs:{"id":"video-container"}},[(!_vm.isMobile)?_c('video',{staticClass:"video-element",attrs:{"id":"is-video","muted":"","autoplay":"autoplay","preload":"auto","loop":"","width":"1160","height":"652","poster":"/video/poster.jpg","webkit-playsinline":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":"/video/alt.mp4","align":"right","type":"video/mp4"}})]):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('div',{staticClass:"mobile-video",attrs:{"alt":"intro video"}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"entry-content"},[_c('div',{staticClass:"homepage-grid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"left stack"},[_c('div',{staticClass:"top animateIn"},[_c('div',{staticClass:"text"},[_c('h2',{staticClass:"title"},[_vm._v("We’re a friendly bunch, down-to-earth and honest. We pride ourselves on long lasting client relationships.")]),_vm._v(" "),_c('p',{staticClass:"more"},[_c('router-link',{attrs:{"to":"/about"}},[_vm._v("Take a peek")])],1)])]),_vm._v(" "),_c('div',{staticClass:"bottom animateIn"},[_c('router-link',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.$store.state.url + '/assets/images/simpson.png'),expression:"$store.state.url + '/assets/images/simpson.png'",arg:"background-image"}],staticClass:"block whitePeak",style:({ backgroundColor: '#FFFFFF', color: '#2E2E2E' }),attrs:{"to":"/work/simpson-marine"}},[_c('p',{staticClass:"sector"},[_vm._v("Work")]),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("Simpson Marine")])])],1)]),_vm._v(" "),_c('div',{staticClass:"right animateIn"},[_c('router-link',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.$store.state.url + '/assets/images/shipping_building.png'),expression:"$store.state.url + '/assets/images/shipping_building.png'",arg:"background-image"}],staticClass:"block cabyn",style:({ backgroundColor: '#EBEBED', color: '#3D392E' }),attrs:{"to":"/work/shipping-building"}},[_c('p',{staticClass:"sector"},[_vm._v("Work")]),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("Shipping Building")])])],1)]),_vm._v(" "),_c('div',{staticClass:"row stack"},[_c('div',{staticClass:"left wide animateIn"},[_c('router-link',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.$store.state.url + '/assets/images/golfing-days.gif'),expression:"$store.state.url + '/assets/images/golfing-days.gif'",arg:"background-image"}],staticClass:"block neo",style:({ backgroundColor: '#323B3C', color: '#FFFFFF' }),attrs:{"to":"/work/golfing-days"}},[_c('p',{staticClass:"sector"},[_vm._v("Work")]),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("Golfing Days")])])],1),_vm._v(" "),_c('div',{staticClass:"right narrow animateIn"},[_c('instagram',{attrs:{"token":_vm.instaToken,"username":"_altdesign","count":2}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"left "},[_c('router-link',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.$store.state.url + '/assets/images/hannells.png'),expression:"$store.state.url + '/assets/images/hannells.png'",arg:"background-image"}],staticClass:"block black joanie medium animateIn",style:({ backgroundColor: '#FFD008', color: '#000000' }),attrs:{"to":"/work/hannells"}},[_c('p',{staticClass:"sector"},[_vm._v("Work")]),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("Hannells")])]),_vm._v(" "),_c('router-link',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.$store.state.url + '/assets/images/invest_in_derbyshire.gif'),expression:"$store.state.url + '/assets/images/invest_in_derbyshire.gif'",arg:"background-image"}],staticClass:"block robinson medium animateIn",style:({ backgroundColor: '#C3CF27', color: '#FFFFFF' }),attrs:{"to":"/work/invest-in-derbyshire"}},[_c('p',{staticClass:"sector"},[_vm._v("Work")]),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("Invest in Derbyshire")])])],1),_vm._v(" "),_c('div',{staticClass:"right animateIn"},[_c('router-link',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:(_vm.$store.state.url + '/assets/images/sea_lng.png'),expression:"$store.state.url + '/assets/images/sea_lng.png'",arg:"background-image"}],staticClass:"block princess tall",style:({ backgroundColor: '#85BFD9', color: '#FFFFFF' }),attrs:{"to":"/work/sea-lng"}},[_c('p',{staticClass:"sector"},[_vm._v("Work")]),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("Sea LNG")])])],1)])]),_vm._v(" "),_vm._m(1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"entry-title"},[_vm._v("We make things"),_c('br'),_vm._v("look good.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-buttons animateIn"},[_c('ul',[_c('h2',{staticClass:"title"},[_vm._v("Follow us!")]),_vm._v(" "),_c('li',{staticClass:"facebook"},[_c('a',{attrs:{"href":"https://www.facebook.com/altdesignderby/","target":"_blank","title":"Find us on Facebook"}},[_c('span',{staticClass:"icon-facebook"})])]),_vm._v(" "),_c('li',{staticClass:"twitter"},[_c('a',{attrs:{"href":"https://twitter.com/_altdesign","target":"_blank","title":"Follow us on Twitter"}},[_c('span',{staticClass:"icon-twitter"})])]),_vm._v(" "),_c('li',{staticClass:"instagram"},[_c('a',{attrs:{"href":"https://www.instagram.com/_altdesign/","target":"_blank","title":"Follow us on Instagram"}},[_c('span',{staticClass:"icon-instagram"})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/12.7806f59754eccfa7428d.js